import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../components/auth/AuthProvider'
import SessionTimeout from '../components/SessionTimeout'

/**
 * Standalone session-timeout page when token is missing or expired (no token in localStorage).
 * If user has session (token in localStorage), redirect to chat. Otherwise show SessionTimeout.
 */
export function SessionTimeoutPage() {
  const navigate = useNavigate()
  const { isSignedIn, loading } = useAuth()

  useEffect(() => {
    if (!loading && isSignedIn) navigate('/ochat', { replace: true })
  }, [loading, isSignedIn, navigate])

  if (loading || isSignedIn) return null
  return <SessionTimeout visible />
}
